import { Badge, Card, Group, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { NavItem } from '@/app/navigation';

/** Platzhalter für Bereiche, die in späteren Phasen umgesetzt werden. */
export function ComingSoon({ item }: { item: NavItem }) {
  const { t } = useTranslation();
  const Icon = item.icon;

  return (
    <Stack gap="lg" maw={720}>
      <Title order={2}>{t(`nav.items.${item.key}`)}</Title>
      <Card withBorder padding="xl">
        <Group align="flex-start" wrap="nowrap">
          <Icon size={40} stroke={1.4} color="var(--mantine-color-orange-6)" />
          <Stack gap={6}>
            <Group gap="xs">
              <Text fw={600}>{t('comingSoon.title')}</Text>
              <Badge variant="light">{t('comingSoon.phase', { phase: item.phase })}</Badge>
            </Group>
            <Text c="dimmed" size="sm">
              {t('comingSoon.description')}
            </Text>
            <Text size="xs" c="dimmed">
              {t('comingSoon.features', { features: item.features })}
            </Text>
          </Stack>
        </Group>
      </Card>
    </Stack>
  );
}
